export class DragContext {
    id: string = null;
    startPosition: number = null;

    constructor(id: string, startPosition: number) {
        this.id = id;
        this.startPosition = startPosition;
    }
}